import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  _UInt___init__impl__l7qpdl5ip6p2ldulrs as _UInt___init__impl__l7qpdl,
  UInt__toString_impl_dbgl212c25g5qzedjl1 as UInt__toString_impl_dbgl21,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import {
  _ULong___init__impl__c78o9k1vasxel72m2l4 as _ULong___init__impl__c78o9k,
  ULong__toString_impl_f9au7k36l427nkiqphd as ULong__toString_impl_f9au7k,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import {
  _UByte___init__impl__g9hnc49zztd2brjj2m as _UByte___init__impl__g9hnc4,
  UByte__toString_impl_v72jg3k7aad61xjb4o as UByte__toString_impl_v72jg,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import {
  _UShort___init__impl__jigrne1e3nphhrejdd8 as _UShort___init__impl__jigrne,
  UShort__toString_impl_edaoee2vx1is7vlchpz as UShort__toString_impl_edaoee,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ComposerClass;
function Composer() {
  if (ComposerClass === VOID) {
    class $ {
      constructor(writer) {
        this.v2s_1 = writer;
        this.w2s_1 = true;
      }
      x2s() {
        this.w2s_1 = true;
      }
      y2s() {
        return Unit_instance;
      }
      z2s() {
        this.w2s_1 = false;
      }
      a2t() {
        this.w2s_1 = false;
      }
      b2t() {
        return Unit_instance;
      }
      c2t(v) {
        return this.v2s_1.d2t(v);
      }
      e2t(v) {
        return this.v2s_1.f2t(v);
      }
      g2t(v) {
        return this.v2s_1.f2t(v.toString());
      }
      h2t(v) {
        return this.v2s_1.f2t(v.toString());
      }
      i2t(v) {
        return this.v2s_1.j2t(fromInt(v));
      }
      k2t(v) {
        return this.v2s_1.j2t(fromInt(v));
      }
      l2t(v) {
        return this.v2s_1.j2t(fromInt(v));
      }
      m2t(v) {
        return this.v2s_1.j2t(v);
      }
      n2t(v) {
        return this.v2s_1.f2t(v.toString());
      }
      o2t(value) {
        return this.v2s_1.p2t(value);
      }
    }
    initMetadataForClass($, 'Composer');
    ComposerClass = $;
  }
  return ComposerClass;
}
function Composer_0(sb, json) {
  return json.z2n_1.r2p_1 ? new (ComposerWithPrettyPrint())(sb, json) : new (Composer())(sb);
}
var ComposerForUnsignedNumbersClass;
function ComposerForUnsignedNumbers() {
  if (ComposerForUnsignedNumbersClass === VOID) {
    class $ extends Composer() {
      constructor(writer, forceQuoting) {
        super(writer);
        this.s2t_1 = forceQuoting;
      }
      l2t(v) {
        if (this.s2t_1) {
          // Inline function 'kotlin.toUInt' call
          var tmp$ret$0 = _UInt___init__impl__l7qpdl(v);
          this.o2t(UInt__toString_impl_dbgl21(tmp$ret$0));
        } else {
          // Inline function 'kotlin.toUInt' call
          var tmp$ret$1 = _UInt___init__impl__l7qpdl(v);
          this.e2t(UInt__toString_impl_dbgl21(tmp$ret$1));
        }
      }
      m2t(v) {
        if (this.s2t_1) {
          // Inline function 'kotlin.toULong' call
          var tmp$ret$0 = _ULong___init__impl__c78o9k(v);
          this.o2t(ULong__toString_impl_f9au7k(tmp$ret$0));
        } else {
          // Inline function 'kotlin.toULong' call
          var tmp$ret$1 = _ULong___init__impl__c78o9k(v);
          this.e2t(ULong__toString_impl_f9au7k(tmp$ret$1));
        }
      }
      i2t(v) {
        if (this.s2t_1) {
          // Inline function 'kotlin.toUByte' call
          var tmp$ret$0 = _UByte___init__impl__g9hnc4(v);
          this.o2t(UByte__toString_impl_v72jg(tmp$ret$0));
        } else {
          // Inline function 'kotlin.toUByte' call
          var tmp$ret$1 = _UByte___init__impl__g9hnc4(v);
          this.e2t(UByte__toString_impl_v72jg(tmp$ret$1));
        }
      }
      k2t(v) {
        if (this.s2t_1) {
          // Inline function 'kotlin.toUShort' call
          var tmp$ret$0 = _UShort___init__impl__jigrne(v);
          this.o2t(UShort__toString_impl_edaoee(tmp$ret$0));
        } else {
          // Inline function 'kotlin.toUShort' call
          var tmp$ret$1 = _UShort___init__impl__jigrne(v);
          this.e2t(UShort__toString_impl_edaoee(tmp$ret$1));
        }
      }
    }
    initMetadataForClass($, 'ComposerForUnsignedNumbers');
    ComposerForUnsignedNumbersClass = $;
  }
  return ComposerForUnsignedNumbersClass;
}
var ComposerForUnquotedLiteralsClass;
function ComposerForUnquotedLiterals() {
  if (ComposerForUnquotedLiteralsClass === VOID) {
    class $ extends Composer() {
      constructor(writer, forceQuoting) {
        super(writer);
        this.v2t_1 = forceQuoting;
      }
      o2t(value) {
        if (this.v2t_1) {
          super.o2t(value);
        } else {
          super.e2t(value);
        }
      }
    }
    initMetadataForClass($, 'ComposerForUnquotedLiterals');
    ComposerForUnquotedLiteralsClass = $;
  }
  return ComposerForUnquotedLiteralsClass;
}
var ComposerWithPrettyPrintClass;
function ComposerWithPrettyPrint() {
  if (ComposerWithPrettyPrintClass === VOID) {
    class $ extends Composer() {
      constructor(writer, json) {
        super(writer);
        this.y2t_1 = json;
        this.z2t_1 = 0;
      }
      x2s() {
        this.w2s_1 = true;
        this.z2t_1 = this.z2t_1 + 1 | 0;
      }
      y2s() {
        this.z2t_1 = this.z2t_1 - 1 | 0;
      }
      z2s() {
        this.w2s_1 = false;
        this.e2t('\n');
        // Inline function 'kotlin.repeat' call
        var times = this.z2t_1;
        var inductionVariable = 0;
        if (inductionVariable < times)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this.e2t(this.y2t_1.z2n_1.t2p_1);
          }
           while (inductionVariable < times);
      }
      a2t() {
        if (this.w2s_1)
          this.w2s_1 = false;
        else {
          this.z2s();
        }
      }
      b2t() {
        this.c2t(_Char___init__impl__6a9atx(32));
      }
    }
    initMetadataForClass($, 'ComposerWithPrettyPrint');
    ComposerWithPrettyPrintClass = $;
  }
  return ComposerWithPrettyPrintClass;
}
//region block: exports
export {
  ComposerForUnquotedLiterals as ComposerForUnquotedLiterals3v0rwxdudtla9,
  ComposerForUnsignedNumbers as ComposerForUnsignedNumbers2h1dv6l9z3aef,
  Composer_0 as Composer1pt8hwk95abxi,
};
//endregion

//# sourceMappingURL=Composers.mjs.map
